import React, { useEffect, useState, useMemo } from "react";
import styles from "../../../BorrowerDetails.module.css";
import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogContentText,
  MenuItem,
  TextField,
  Tooltip,
} from "@mui/material";
import axios from "axios";
import { url } from "../../../../../../App";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router";
import Cookies from "js-cookie";
import { useBorrowerContext } from "../../../store/borrower-details";
import SingleDocModal from "../SingleDocModal";
import PDFViewer from "../../PDFViewer/PDFViewer";
import { FaClipboard, FaClipboardCheck } from "react-icons/fa";
import MultiDocsModal from "../MultiDocsModal";
import { PDFDocument } from "pdf-lib";
import { AiOutlineEye } from "react-icons/ai";
import { UploadFileOutlined } from "@mui/icons-material";

const KfsModal = ({
  loanDocsExist,
  closeModal,
  // loanDetails,
  openLoader,
  closeLoader,
  permissions,
  isDisbursed,
}) => {
  const Navigate = useNavigate();
  const TOKEN = Cookies.get("Token");
  const EMAIL = Cookies.get("Email");
  const UNIQUE_NO = localStorage.getItem("uniqueID");
  const { loanid } = useParams();
  const { borrowerData, updateBorrowerData } = useBorrowerContext();
  const { borrower, coapplicant } = borrowerData;
  const CoapplicantsArray = [...coapplicant.map((coapplicant) => coapplicant)];
  const fetchedLoanDetails = borrowerData.loan;
  console.log(fetchedLoanDetails, "fetchedLoanDetails");
  const foundLoan = fetchedLoanDetails.find((item) => item.loan_id === loanid);

  useEffect(() => {
    if (foundLoan) {
      setLoanDetails(foundLoan);
    }
  }, [foundLoan]);
  const [loanDetails, setLoanDetails] = useState(foundLoan || null);
  const [esignVal, setEsignVal] = useState("");
  const [loanAgreementLoader, setLoanAgreementLoader] = useState(false);
  const [permission, setPermission] = useState({});
  const [applicantType, setApplicantType] = useState({});
  const [esignModal, setEsignModal] = useState(false);
  const [coapplicantEsign, setCoapplicantEsign] = useState(false);
  const [pdfModal, setPdfModal] = useState({
    open: false,
    data: `data:application/pdf;base64,${url}`,
  });
  const [docModal, setDocModal] = useState(false);
  const [docs, setDocs] = useState([]);
  const [name, setName] = useState("");
  const [openEsignOptionModal, setOpenEsignOptionModal] = useState(false);
  const [openManualModal, setOpenManualModal] = useState(false);
  const [stampPaper, setStampPaper] = useState(null);

  console.log(applicantType);

  const [singleDocModal, setSingleDocModal] = useState({
    open: false,
    doc: "",
    docType: "",
  });
  const [applicationForms, setApplicationForms] = useState(
    loanDetails?.kfs_letter || []
  );

  const handleAuditUpload = (documentId) => {
    let text = `Are you sure you want to upload audit trail?`;
    if (!window.confirm(text)) {
      return;
    }
    document.getElementById(`audit-upload-${documentId}`)?.click();
  };

  const handleLoanAgreementUpload = (documentId) => {
    let text = `Are you sure you want to upload kfs letter?`;
    if (!window.confirm(text)) {
      return;
    }
    document.getElementById(`agreement-upload-${documentId}`)?.click();
  };

  const handleEsignModal = () => {
    setEsignModal(true);
  };

  const handleEsignClose = () => {
    setEsignModal(false);
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const handleCoapplicantEsign = () => {
    setCoapplicantEsign(!coapplicantEsign);
  };
  const [checked, setChecked] = React.useState(false);

  const [copied, setCopied] = useState(false);

  const handleCopy = async (link) => {
    if (!link) {
      toast.error("No link available to copy.");
      return;
    }

    try {
      await navigator.clipboard.writeText(link);
      setCopied(link);
      toast.success("Link copied successfully!");

      setTimeout(() => {
        setCopied(null);
      }, 2000);
    } catch (err) {
      toast.error("Failed to copy link.");
    }
  };

  const applicantChangeHandler = (e, applicant) => {
    const { value } = e.target;
    setApplicantType((prevValues) => ({
      ...prevValues,
      [applicant]: value,
    }));
  };

  const viewDocHandler = async (docName, id) => {
    const { loan_id } = loanDetails;

    const selectedDocs = loanDetails?.[docName]?.filter((doc) => {
      const match = (s) => s?.match(/^(\d+)_.+_(\d+)$/);
      return match(doc.id)?.[1] === match(id)?.[1] && match(doc.id)?.[2] === match(id)?.[2];
    });
    setName(docName === "kfs_letter" ? "KFS" : "KFS AuditTrail");

    if (!selectedDocs || selectedDocs.length === 0) {
      toast.error("No Document Found. Please upload");
      closeLoader();
      return;
    }

    if (selectedDocs === undefined) {
      toast.error("Document not found");
      return;
    }

    const viewArr = await Promise.all(
      selectedDocs.map(async (data, index) => {
        const req = {
          token: Cookies.get("Token"),
          email: Cookies.get("Email"),
          borrower_uniqueno: localStorage.getItem("uniqueID"),
          doc_name: data.doc_name,
          doc_type: "pdf",
          loan_id: loan_id,
        };

        const docNameArr = data.doc_name
          .split("(")[0]
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1));
        const docName = `${docNameArr[0]} ${docNameArr[1]}`;
        setName(docName);
        const res = await axios.post(url + "/loan/viewdoc", req);

        const downloadHandler = async () => {
          const downloadRes = await axios.post(url + "/loan/downloaddoc", req);
          if (!downloadRes.data.auth) {
            toast.error(downloadRes.data.message);
            return;
          }
          const downloadLink = document.createElement("a");
          const linkSource = `data:application/pdf;base64,${downloadRes.data.doc_base64}`;
          const fileName = `${req.borrower_uniqueno} Loan${req.loan_id} ${req.doc_name}.pdf`;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        };

        const deleteHandelr = async () => {
          const text = `Are you sure you want to delete ${req.doc_name}?`;
          if (!window.confirm(text)) {
            return;
          }
          const deleteReq = {
            token: Cookies.get("Token"),
            email: Cookies.get("Email"),
            borrower_uniqueno: localStorage.getItem("uniqueID"),
            loan_id: loan_id,
            doc_arr: {
              location: data.location,
              doc_type: "pdf",
              doc_name: data.doc_name,
            },
          };
          const deleteRes = await axios.post(
            url + "/loan/deletedoc",
            deleteReq
          );
          if (!deleteRes.data.auth) {
            return toast.error(deleteRes.data.message);
          }
          toast.success(deleteRes.data.message);
          window.location.reload();
        };

        return {
          doc: res.data.doc_base64,
          docType: req.doc_type,
          download: downloadHandler,
          delete: deleteHandelr,
        };
      })
    );
    if (viewArr.length === 0) {
      toast.error("No docs found");
      return;
    }
    setDocs(viewArr);
    setDocModal(true);
  };

  const closeDocModal = () => {
    setDocModal(false);
  };

  useEffect(() => {
    try {
      setPermission({
        upload: permissions.add_loan_document,
        view: permissions.view_loan_document,
        download: permissions.download_loan_document,
        delete: permissions.delete_loan_document,
        view_kfs_letter: permissions.view_kfs_letter,
        download_kfs_letter: permissions.download_kfs_letter,
        upload_kfs_letter: permissions.upload_kfs_letter,
        generate_kfs_letter: permissions.generate_kfs_letter,
        initiate_kfs_letter: permissions.initiate_kfs_letter,
        signed_kfs_letter: permissions.signed_kfs_letter,
        view_application_form_doc: permissions.view_application_form_doc,
        download_application_form_doc:
          permissions.download_application_form_doc,
        generate_application_form_doc:
          permissions.generate_application_form_doc,
        initiate_application_form_doc:
          permissions.initiate_application_form_doc,
        signed_application_form_doc: permissions.signed_application_form_doc,
        view_loan_agreement: permissions.view_loan_agreement,
        download_loan_agreement: permissions.download_loan_agreement,
        delete_loan_agreement: permissions.delete_loan_agreement,
        generate_loan_agreement: permissions.generate_loan_agreement,
        initiate_loan_agreement: permissions.initiate_loan_agreement,
        upload_audit_trail: permissions.upload_audit_trail,
        view_audit_trail: permissions.view_audit_trail,
        download_audit_trail: permissions.download_audit_trail,
        delete_audit_trail: permissions.delete_audit_trail,
        fetch_kfs_letter: permissions.fetch_kfs_letter,
      });
    } catch (err) {
      console.log(err);
    }
  }, [permissions]);

  const getSingleEsignDetails = async () => {
    try {
      openLoader();
      const { loan_id } = loanDetails;

      const request = {
        token: TOKEN,
        email: EMAIL,
        loan_id: loan_id,
        esignReason: "kfs_letter",
      };

      await axios.post(url + "/loan/getesign", request);

      const response = await axios.post(url + "/api/fetch/esign/details", {
        loanId: loan_id,
        token: TOKEN,
        email: EMAIL,
      });

      if (response.data.success) {
        const esignDataList = response.data.data || [];
        setApplicationForms((prevForms) =>
          prevForms.map((loan) => {
            const matchingEsign = esignDataList.find(
              (item) => item.digioid === loan.did
            );
            if (!matchingEsign) return loan;
            return {
              ...loan,
              signing_parties: (loan.signing_parties || []).map((party) => ({
                ...party,
                status:
                  party.name === matchingEsign?.Signer1
                    ? matchingEsign?.Signer1status || party.status
                    : party.name === matchingEsign?.Signer2
                    ? matchingEsign?.Signer2status || party.status
                    : party.name === matchingEsign?.Signer3
                    ? matchingEsign?.Signer3status || party.status
                    : party.status,
              })),
            };
          })
        );
      } else {
        console.error("Failed to fetch e-sign details");
      }

      closeLoader();
    } catch (err) {
      console.error("Error in getSingleEsignDetails:", err.message);
      closeLoader();
    }
  };
  const initiateEsignHandler = () => {
    setOpenEsignOptionModal(true);
  };

  const handleEsignOption = async (type) => {
    setOpenEsignOptionModal(false);

    if (type === "api") {
      handleEsign("Loan Agreement");
    }

    if (type === "manual") {
      setOpenManualModal(true);
      setStampPaper(null);
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const base64ToUint8Array = (base64) => {
    const cleanedBase64 = base64.includes(",") ? base64.split(",")[1] : base64;

    const binaryString = window.atob(cleanedBase64);

    const bytes = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return bytes;
  };

  const uploadStampPaperHandler = async () => {
    if (!stampPaper) {
      return toast.error("Please upload stamp paper");
    }
    const file = stampPaper.target.files[0];

    if (file.type !== "application/pdf") {
      return toast.error("Only PDF file is allowed");
    }
    const stampBase64 = await convertToBase64(stampPaper.target.files[0]);
    const { loan_id } = loanDetails;
    const latestLoanAgreement = loanDetails?.kfs_letter?.at(-1);
    const req = {
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
      borrower_uniqueno: localStorage.getItem("uniqueID"),
      doc_name: latestLoanAgreement.doc_name,
      doc_type: "pdf",
      loan_id: loan_id,
    };

    const res = await axios.post(url + "/loan/viewdoc", req);
    const loanAgreementBase64 = res.data?.doc_base64;

    const stampBytes = base64ToUint8Array(stampBase64);
    const agreementBytes = base64ToUint8Array(loanAgreementBase64);

    const stampPdf = await PDFDocument.load(stampBytes);
    const agreementPdf = await PDFDocument.load(agreementBytes);

    const mergedPdf = await PDFDocument.create();

    const stampPages = await mergedPdf.copyPages(
      stampPdf,
      stampPdf.getPageIndices()
    );

    stampPages.forEach((page) => {
      mergedPdf.addPage(page);
    });

    const agreementPages = await mergedPdf.copyPages(
      agreementPdf,
      agreementPdf.getPageIndices()
    );

    agreementPages.forEach((page) => {
      mergedPdf.addPage(page);
    });

    const mergedPdfBytes = await mergedPdf.save();

    const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });

    const base64data = await new Promise((resolve) => {
      const reader = new FileReader();

      reader.readAsDataURL(blob);

      reader.onloadend = () => {
        resolve(reader.result.split(",")[1]);
      };
    });

    const reqOne = {
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
      borrower_uniqueno: localStorage.getItem("uniqueID"),
      fileName: base64data,
      loan_id: loan_id,
      doc_type: "pdf",
      doc_name: "kfs_letter",
      status: "generated",
      id: latestLoanAgreement?.id,
    };

    await axios.post(url + "/loan/adddoc", reqOne);
    await uploadLoanDocHandler(stampPaper, "stamp_paper");
  };

  const handleEsign = async (docType) => {
    let text = `Are you sure you want to initiate esign for kfs letter?`;
    if (!window.confirm(text)) {
      return;
    }
    const { loan_id } = loanDetails;

    openLoader();

    const reqtBody = {
      loanId: loan_id,
      esignReason: docType,
      signPartner: "Digio",
    };
    if (loanDetails) {
      reqtBody[`mobile1`] = loanDetails?.mobile;
    }
    if (borrower) {
      reqtBody[`name1`] = borrower?.borrower_aadhaar_dump?.actions?.[0]?.details?.aadhaar?.name || borrower?.borrower_aadhaar_dump?.name ||
        borrower.borrower_firstname + " " + borrower.borrower_lastname;
      reqtBody[`signerType1`] = "aadhaar";
    }
    if (CoapplicantsArray && CoapplicantsArray.length > 0) {
      CoapplicantsArray.filter(
        (coapplcnt) => coapplcnt.coapplicant_loan_id === loan_id
      ).forEach((coapplcnt, i) => {
        let index = i + 2;
        reqtBody[`mobile${index}`] = coapplcnt.coapplicant_mobile;
        reqtBody[`name${index}`] = coapplcnt?.borrower_aadhaar_dump?.actions?.[0]?.details?.aadhaar?.name || coapplcnt?.borrower_aadhaar_dump?.name ||
          coapplcnt.coapplicant_name;
        reqtBody[`signerType${index}`] = "aadhaar";
      });
    }
    if (reqtBody.signerType1 === undefined) {
      toast.error("Borrower is required");
      return;
    }
    reqtBody.esignManual = openManualModal;
    try {
      const response = await axios.post(
        `${url}/loan/applicationform/esign`,
        reqtBody,
        {
          headers: {
            token: TOKEN,
            email: EMAIL,
          },
        }
      );
      if (response.data.auth) {
        closeLoader();
        toast.success(response.data.message);
        getSingleEsignDetails();
        setApplicantType({});
        setEsignModal(false);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong. Please try again later");
      }
    }
    closeLoader();
    setApplicantType({});
    setEsignModal(false);
  };

  const closePdfViewer = () => {
    setPdfModal((prevState) => ({
      ...prevState,
      open: false,
      data: "",
    }));
  };

  const closeSingleDocModal = () => {
    setSingleDocModal((prevState) => ({
      ...prevState,
      open: false,
    }));
  };

  const getApplicationForm = async (docType) => {
    let text = `Are you sure you want to generate kfs letter?`;
    if (!window.confirm(text)) {
      return;
    }
    const { loan_id } = loanDetails;

    setLoanAgreementLoader(true);
    try {
      const response = await axios.post(
        `${url}/application/generatedynamicfield`,
        {
          loan_id: loan_id,
          doc_type: docType,
        },
        {
          headers: {
            token: TOKEN,
            email: EMAIL,
          },
        }
      );

      if (response.data.auth) {
        toast.success(response.data.message);
        const updateBorrower = await axios.post(
          url + "/borrower/borrowertoalldetails",
          {
            token: TOKEN,
            email: EMAIL,
            borrower_uniqueno: UNIQUE_NO,
          }
        );

        if (updateBorrower.data.auth) {
          const updatedLoan = updateBorrower.data.message.loan;
          const foundLoan = updatedLoan.find((item) => item.loan_id === loanid);

          updateBorrowerData((prevState) => ({
            ...prevState,
            loan: updatedLoan,
          }));

          setApplicationForms(foundLoan?.kfs_letter || []);
        }
      }
    } catch (error) {
      console.error("Error fetching kfs letter:", error);
      toast.error("Failed to fetch kfs letter. Please try again.");
    } finally {
      setLoanAgreementLoader(false);
    }
  };

  useEffect(() => {
    setApplicationForms(loanDetails?.kfs_letter || []);
  }, [loanDetails?.kfs_letter]);

  const esignInitiate = async () => {
    const { loan_id } = loanDetails;

    const esignReq = {
      token: TOKEN,
      email: EMAIL,
      borrower_uniqueno: UNIQUE_NO,
      loan_id: loan_id,
      loan_esign_by: esignVal,
    };
    const esignRes = await axios.post(url + "/loan/esign", esignReq);
    closeLoader();
    if (!esignRes.data.auth) {
      toast.error(esignRes.data.message);
      return;
    } else {
      toast.success(esignRes.data.message);
      setApplicantType({});
      setEsignModal(false);
      closeModal();
    }
  };

  //eslint-disable-next-line
  const uploadLoanDocHandler = (e, docName, id) => {
    const { loan_id } = loanDetails;

    openLoader();
    try {
      let address = e.target.files[0];
      if (!address) {
        closeLoader();
        return;
      }
      const docType = address.name.split(".").pop();
      if (docType !== "pdf" && docType !== "jpg" && docType !== "png") {
        closeLoader();
        toast.error("Please upload in PDF or Jpg or Png format only");
        return;
      }

      let reader = new FileReader();
      reader.readAsDataURL(address);
      reader.onload = async (eve) => {
        const base64data = eve.target.result.split(",").pop();
        const req = {
          token: Cookies.get("Token"),
          email: Cookies.get("Email"),
          borrower_uniqueno: localStorage.getItem("uniqueID"),
          fileName: base64data,
          loan_id: loan_id,
          doc_type: docType,
          doc_name: docName,
          id: id,
        };
        const res = await axios.post(url + "/loan/adddoc", req);
        if (!res.data.auth) {
          if (res.data.logout) {
            closeLoader();
            Navigate("/");
            return;
          }
          toast.error(res.data.message);
          closeLoader();
          return;
        }
        const updateBorrower = await axios.post(
          url + "/borrower/borrowertoalldetails",
          {
            token: Cookies.get("Token"),
            email: Cookies.get("Email"),
            borrower_uniqueno: localStorage.getItem("uniqueID"),
          }
        );
        if (!updateBorrower.data.auth) {
          closeLoader();
          return;
        }
        updateBorrowerData((prevState) => ({
          ...prevState,
          loan: updateBorrower.data.message.loan,
        }));

        toast.success(res.data.message);
        closeLoader();
        if (docName !== "stamp_paper") {
          closeModal();
        }
        return;
      };
    } catch (err) {
      toast.error("An error occoured");
      console.error(err);
      closeLoader();
      return;
    }
  };

  const groupedEsignData = useMemo(() => {
    if (!applicationForms?.length) return {};

    const sortedForms = [...applicationForms].sort((a, b) => {
      const dateA = new Date(a.timestamp || 0);
      const dateB = new Date(b.timestamp || 0);
      return dateB - dateA;
    });

    return sortedForms.reduce((acc, loan) => {
      const digioid = loan.did || loan.id;
      acc[digioid] = {
        digioid: loan.did || "",
        document_id: loan.id || null,
        timestamp: loan.timestamp || "-",
        esignInitiatedDate: loan.esignInitiatedDate || "-",
        signers:
          loan?.signing_parties?.length > 0
            ? loan.signing_parties
            : [
                {
                  name: loanDetails?.borrower_name || "-",
                  mobile: loanDetails?.mobile || "-",
                  status: loan.status || "-",
                  authentication_url: "",
                },
              ],
      };

      return acc;
    }, {});
  }, [loanDetails, applicationForms]);

  return (
    <>
      <div className={styles.topBar}>
        <h2>KFS/Sanction Letter Details</h2>
        <CloseIcon onClick={() => closeModal()} className={styles.CloseIcon} />
      </div>
      {pdfModal.open && (
        <PDFViewer url={pdfModal.data} closeModal={closePdfViewer} />
      )}
      {singleDocModal.open && (
        <SingleDocModal
          doc={singleDocModal.doc}
          docType={singleDocModal.docType}
          closeModal={closeSingleDocModal}
          isDownload={permissions?.download_kfs_letter}
          isDelete={permissions?.delete_kfs_letter}
        />
      )}
      {docModal && (
        <MultiDocsModal
          array={docs}
          closeModal={closeDocModal}
          title={name}
          isDownload={permissions?.download_kfs_letter}
          isDelete={permissions?.delete_kfs_letter}
        />
      )}
      <div className={styles.esignContent}>
        <div className={styles.esignActionWrapper}>
          <div>
            {loanDocsExist?.kfsLetter ? (
              <div className={styles.loanBtns}>
                {permission.generate_kfs_letter &&
                  (loanAgreementLoader ? (
                    <button disabled className={styles.DownloadLoanBtn}>
                      <CircularProgress size={12} color="inherit" />
                    </button>
                  ) : (
                    <button
                      className={styles.DownloadLoanBtn}
                      onClick={() => getApplicationForm("KFS")}
                    >
                      Regenerate
                    </button>
                  ))}
                {permission.initiate_kfs_letter && (
                  <button
                    className={styles.DownloadLoanBtn}
                    onClick={() => handleEsign("KFS")}
                    style={{
                      whiteSpace: "nowrap",
                      width: "auto",
                    }}
                  >
                    Initiate Esign
                  </button>
                )}
                {permission.fetch_kfs_letter && (
                  <button
                    className={styles.DownloadLoanBtn}
                    onClick={() => getSingleEsignDetails()}
                  >
                    Fetch Details
                  </button>
                )}
                <Dialog
                  open={esignModal}
                  onClose={handleEsignModal}
                  PaperProps={{
                    component: "form",
                    onSubmit: (event) => {
                      event.preventDefault();
                      handleEsignClose();
                    },
                  }}
                >
                  <DialogContent>
                    <DialogContentText>
                      Do you want to initiate a E-Sign{" "}
                      <Checkbox onChange={handleChange} />
                    </DialogContentText>
                    {checked ? (
                      <div>
                        <div>
                          <label htmlFor="">
                            <>
                              {borrower.borrower_firstname}{" "}
                              {borrower.borrower_lastname}
                            </>
                          </label>
                          <TextField
                            size="small"
                            select
                            className={styles.modalSel}
                            variant="outlined"
                            onChange={(e) =>
                              applicantChangeHandler(e, "borrower")
                            }
                          >
                            <MenuItem value="aadhaar">aadhaar</MenuItem>
                            <MenuItem value="electronic">electronic</MenuItem>
                          </TextField>
                        </div>
                        <div>
                          <label>
                            Do you want to initiate a E-Sign for Co-Applicant
                          </label>{" "}
                          <Checkbox onChange={handleCoapplicantEsign} />
                        </div>
                        {coapplicantEsign ? (
                          <div>
                            {CoapplicantsArray.map((item, index) => (
                              <div key={index}>
                                <label htmlFor="">
                                  <>{item}</>
                                </label>
                                <TextField
                                  size="small"
                                  select
                                  className={styles.modalSel}
                                  variant="outlined"
                                  onChange={(e) =>
                                    applicantChangeHandler(e, item)
                                  }
                                >
                                  <MenuItem value="aadhaar">aadhaar</MenuItem>
                                  <MenuItem value="electronic">
                                    electronic
                                  </MenuItem>
                                </TextField>
                              </div>
                            ))}
                          </div>
                        ) : null}
                        <Button onClick={initiateEsignHandler}>Submit</Button>
                      </div>
                    ) : null}
                  </DialogContent>
                </Dialog>
              </div>
            ) : (
              <>
                {permission.generate_kfs_letter &&
                  (loanAgreementLoader ? (
                    <button disabled className={styles.DownloadLoanBtn}>
                      <CircularProgress size={12} color="inherit" />
                    </button>
                  ) : (
                    <button
                      onClick={() => getApplicationForm("KFS")}
                      className={styles.DownloadLoanBtn}
                    >
                      Generate
                    </button>
                  ))}
              </>
            )}
          </div>
        </div>

        <div className={styles.tableContainer}>
          <div className={styles.tableDiv}>
            <table className={styles.customTable}>
              <thead>
                <tr>
                  <th>DOCUMENT ID</th>
                  <th>SIGNER NAME</th>
                  <th>STATUS</th>
                  {/* <th>SIGNER CONTACT</th> */}
                  <th>LINK</th>
                  {(permission?.upload_kfs_letter ||
                    permission?.view_kfs_letter) && (
                      <>
                        <th>DOCUMENT</th>
                        <th>AUDIT TRAIL</th>
                      </>
                    )}
                </tr>
              </thead>
              <tbody>
                {Object.values(groupedEsignData).map((group) =>
                  group.signers.map((signer, index) => (
                    <tr key={`${group.digioid}-${index}`}>
                      {index === 0 && (
                        <td
                          rowSpan={group.signers.length}
                          className="font-medium"
                          style={{
                            maxWidth: "180px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <Tooltip title={group?.document_id} arrow>
                              <span
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  cursor: "pointer",
                                }}
                              >
                                {group?.document_id}
                              </span>
                            </Tooltip>
                            <Tooltip title={group?.digioid} arrow>
                              <span style={{ display: "flex" }}>
                                <AiOutlineEye
                                  cursor="pointer"
                                  size={20}
                                />
                              </span>
                            </Tooltip>
                          </div>
                        </td>
                      )}

                      <td>{signer.name}</td>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <span
                            className={`px-2 py-1 text-xs rounded-full ${signer.status === "signed"
                              ? "bg-green-100 text-green-700"
                              : "bg-yellow-100 text-yellow-700"
                              }`}
                          >
                            {signer.status}
                          </span>
                        </div>
                      </td>

                      <td className="text-center">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          {signer.authentication_url ? (
                            <button
                              onClick={() => handleCopy(signer.authentication_url)}
                              className="text-blue-600 hover:text-blue-800"
                            >
                              {copied === signer.authentication_url ? (
                                <FaClipboardCheck cursor="pointer" size={18} />
                              ) : (
                                <FaClipboard cursor="pointer" size={18} />
                              )}
                            </button>
                          ) : (
                            <FaClipboard
                              className="text-gray-400"
                              cursor="pointer"
                              size={18}
                            />
                          )}
                        </div>
                      </td>
                      {index === 0 &&
                        (permission?.upload_kfs_letter ||
                          permission?.view_kfs_letter) && (
                          <td
                            rowSpan={group.signers.length}
                            className="text-center"
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              {permission?.view_kfs_letter && (
                                <AiOutlineEye
                                  cursor="pointer"
                                  size={20}
                                  onClick={() =>
                                    viewDocHandler(
                                      "kfs_letter",
                                      group?.document_id
                                    )
                                  }
                                />
                              )}

                              {permission?.upload_kfs_letter && (
                                <>
                                  <input
                                    type="file"
                                    className={styles.loanInputFile}
                                    id={`agreement-upload-${group?.document_id}`}
                                    onChange={(e) =>
                                      uploadLoanDocHandler(
                                        e,
                                        "kfs_letter",
                                        group?.document_id
                                      )
                                    }
                                  />

                                  <UploadFileOutlined
                                    cursor="pointer"
                                    size={16}
                                    onClick={() =>
                                      handleLoanAgreementUpload(
                                        group?.document_id
                                      )
                                    }
                                  />
                                </>
                              )}
                            </div>

                          <span
                            style={{
                              fontSize: "11px",
                              color: "#6b7280",
                            }}
                          > <strong> Initiated At:</strong> <nbsp />
                            {group?.esignInitiatedDate
                              ? new Date(group.esignInitiatedDate).toLocaleString()
                              : "-"}
                          </span>
                          <br />
                          <span
                            style={{
                              fontSize: "11px",
                              color: "#6b7280",
                            }}
                          > <strong>Updated At:</strong> <nbsp />
                            {group?.timestamp
                              ? new Date(group.timestamp).toLocaleString()
                              : "-"}
                          </span>
                          </td>
                        )}

                      {index === 0 &&
                        (permission?.upload_kfs_letter ||
                          permission?.view_kfs_letter) && (
                          <td
                            rowSpan={group.signers.length}
                            className="text-center"
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              {permission?.view_kfs_letter && (
                                <AiOutlineEye
                                  cursor="pointer"
                                  size={20}
                                  onClick={() =>
                                    viewDocHandler(
                                      "kfs_audit_trail",
                                      group?.document_id
                                    )
                                  }
                                />
                              )}

                              {permission?.upload_kfs_letter && (
                                <>
                                  <input
                                    type="file"
                                    className={styles.loanInputFile}
                                    id={`audit-upload-${group?.document_id}`}
                                    onChange={(e) =>
                                      uploadLoanDocHandler(
                                        e,
                                        "kfs_audit_trail",
                                        group?.document_id
                                      )
                                    }
                                  />

                                  <UploadFileOutlined
                                    cursor="pointer"
                                    size={16}
                                    onClick={() =>
                                      handleAuditUpload(group?.document_id)
                                    }
                                  />
                                </>
                              )}
                            </div>
                          </td>
                        )}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        <Dialog
          open={esignModal}
          onClose={handleEsignClose}
          PaperProps={{
            component: "form",
            onSubmit: (event) => {
              event.preventDefault();
              handleEsignClose();
            },
          }}
        >
          <DialogContent>
            <DialogContentText>
              Do you want to initiate a E-Sign{" "}
              <Checkbox onChange={handleChange} />
            </DialogContentText>
            {checked ? (
              <div>
                <div>
                  <label htmlFor="">
                    <>
                      {borrower.borrower_firstname} {borrower.borrower_lastname}
                    </>
                  </label>
                  <TextField
                    size="small"
                    select
                    className={styles.modalSel}
                    variant="outlined"
                    onChange={(e) => applicantChangeHandler(e, "borrower")}
                  >
                    <MenuItem value="aadhaar">aadhaar</MenuItem>
                    <MenuItem value="electronic">electronic</MenuItem>
                  </TextField>
                </div>
                <div>
                  <label>
                    Do you want to initiate a E-Sign for Co-Applicant
                  </label>{" "}
                  <Checkbox onChange={handleCoapplicantEsign} />
                </div>
                {coapplicantEsign ? (
                  <div>
                    {CoapplicantsArray.map((item, index) => (
                      <div key={index}>
                        <label htmlFor="">
                          <>{item}</>
                        </label>
                        <TextField
                          size="small"
                          select
                          className={styles.modalSel}
                          variant="outlined"
                          onChange={(e) => applicantChangeHandler(e, item)}
                        >
                          <MenuItem value="aadhaar">aadhaar</MenuItem>
                          <MenuItem value="electronic">electronic</MenuItem>
                        </TextField>
                      </div>
                    ))}
                  </div>
                ) : null}
                <Button onClick={esignInitiate}>Submit</Button>
              </div>
            ) : null}
          </DialogContent>
        </Dialog>
      </div>

      {openEsignOptionModal && (
        <div className="modal">
          <div className="modal-content">
            <label style={{ fontSize: "12px" }}>Select Esign Option</label>

            <br />

            <TextField
              size="small"
              select
              required
              value={esignVal}
              variant="outlined"
              onChange={(e) => setEsignVal(e.target.value)}
              style={{ marginBottom: 15, width: "22rem" }}
            >
              <MenuItem value="api">API</MenuItem>

              <MenuItem value="manual">Manual</MenuItem>
            </TextField>

            <br />

            <button
              className={styles.DownloadLoanBtn}
              onClick={() => handleEsignOption(esignVal)}
            >
              Initiate Esign
            </button>

            <button
              className={styles.DownloadLoanBtn}
              style={{ marginLeft: 10 }}
              onClick={() => setOpenEsignOptionModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {openManualModal && (
        <div className="modal">
          <div className="modal-content">
            <h3>Upload Stamp Paper</h3>
            <br />

            <input type="file" onChange={(e) => setStampPaper(e)} />
            <br />
            <br />
            <br />

            <button
              className={styles.DownloadLoanBtn}
              onClick={uploadStampPaperHandler}
            >
              Merge Stamp with agreement
            </button>

            {stampPaper && (
              <button
                className={styles.DownloadLoanBtn}
                onClick={() => handleEsign("KFS")}
              >
                Initiate Esign
              </button>
            )}

            <button
              className={styles.DownloadLoanBtn}
              onClick={() => setOpenManualModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default KfsModal;
